import { render, staticRenderFns } from "./TopluUrunResmi.vue?vue&type=template&id=d4493ca2&"
import script from "./TopluUrunResmi.vue?vue&type=script&lang=js&"
export * from "./TopluUrunResmi.vue?vue&type=script&lang=js&"
import style0 from "./TopluUrunResmi.vue?vue&type=style&index=0&id=d4493ca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports